<div fxFlex="100">
    <span (click)="close()" style="padding: 0px ; HEIGHT: 0PX;margin: 0px;" mat-dialog-title>
        <span (click)="close()" fxLayout="row" fxLayoutAlign="end center">
            <button (click)="close()" mat-icon-button>
                <mat-icon>close</mat-icon>
            </button>
        </span>
    </span>

    <div class="padding-10">
        {{name}}
    </div>

    <hr style="border: 1px solid gray;">

    <mat-dialog-content style=" margin: 0px;  max-height: 100%;
    padding: 0px;">
        <div fxLayout="row">
            <div fxFlex="100">
                <div fxFlex="100" style="width:100%; padding:10px" *ngIf="type==1" fxLayout="column"
                    fxLayoutAlign="center center">

                    <calsoft-table style="width:100%;" fxFlex="100" [tabledata]="value"></calsoft-table>

                </div>

                <div  *ngIf="type==0" fxLayout="column" fxLayoutAlign="start start">
                    <div fxFlex="100" style="width:100%; padding:10px"  >
                        <img [src]="serverPath+imgValue" onerror="this.src='';" style="width: 100%;" />
                    </div>
    
                </div>


            </div>

         
        </div>







        <div *ngIf="description && description.length>0" fxLayout="row" style="width:100%; padding:0px 10px"
            fxLayoutAlign="space-between center">
            {{description}}
        </div>


    </mat-dialog-content>
</div>